import { render, staticRenderFns } from "./SectionIngredientsEdit.vue?vue&type=template&id=f148c692"
import script from "./SectionIngredientsEdit.vue?vue&type=script&lang=js"
export * from "./SectionIngredientsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports